import { render, staticRenderFns } from "./ttfopenaccount.vue?vue&type=template&id=69a12c47&scoped=true&"
import script from "./ttfopenaccount.vue?vue&type=script&lang=js&"
export * from "./ttfopenaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a12c47",
  null
  
)

export default component.exports